import { render } from "./VariationBuilder.vue?vue&type=template&id=3996fd86&scoped=true"
import script from "./VariationBuilder.vue?vue&type=script&lang=js"
export * from "./VariationBuilder.vue?vue&type=script&lang=js"

import "./VariationBuilder.vue?vue&type=style&index=0&id=3996fd86&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3996fd86"

export default script